import Breadcrumbs from "../../../components/breadcrumbs";
import ExerciseLoadTypeCreateForm from "./ui/ExerciseLoadTypeCreateForm";

export default function ExerciseLoadTypeCreatePage() {
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Exercise Load Types", href: "/admin/exercise-load-types" },
          {
            label: "create",
            href: `/admin/exercise-load-types/Create`,
            active: true,
          },
        ]}
      />

      <ExerciseLoadTypeCreateForm />
    </main>
  );
}
